/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aukbrhkegRkQ6KizvhdUPT

import { createUseGlobalVariants } from "@plasmicapp/react-web";

import { useScreenVariants as useScreenVariantsnXbQfeebYy0 } from "../q_4_text_mixins_product/PlasmicGlobalVariant__Screen"; // plasmic-import: NXbQfeebYy0/globalVariant

export const _useGlobalVariants = createUseGlobalVariants({
  screen: useScreenVariantsnXbQfeebYy0,
});
